module.exports = __webpack_public_path__ + "static/media/progress4.6fe8cb9c.png";